import React, { useState, useEffect } from 'react';

import { Button, Space, Card, Tabs,
    Form, Input, InputNumber, Select, Alert, message } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';

import { Settings } from '@urbaneez.art/shared';

interface OrderSettingProps {
    isLoading: boolean,
    settings: Settings | undefined,
    error?: any,
    updateOrderSettings: (updateFields: object) => void,
}

export const OrderSettingsCard: React.FC<OrderSettingProps> = ({
    isLoading,
    settings,
    updateOrderSettings,
    error,
}) => {

    const [form] = Form.useForm();
    form.setFieldValue('orderNumber', settings?.currentOrderNumber);

    const handleFinish = async (updateFields: object | undefined) => {
        if(updateFields){
            try {
                updateOrderSettings(updateFields);
                message.success('Order settings updated successfully!');
            } catch (err) {
                message.error('Failed to update order settings.');
            }
        }
        else{
            message.error('Value passed to the form is null, contact the developer');
        }
    };

    return (
        <Card title="Order Settings" loading={isLoading}>

            {error && (
                <Alert 
                    message="Error loading settings" 
                    description={error.message || 'An unexpected error occurred.'} 
                    type="error" 
                    showIcon 
                    style={{ marginBottom: 16 }}
                />
            )}

            <Form 
                form={form} 
                layout="vertical"
                onFinish={handleFinish}
                initialValues={{orderNumber: 1}}>

                <Form.Item 
                    label="Last order number"
                    name="orderNumber"
                    
                    rules={[{ required: true, message: 'Please enter the current order number' }]}>
                        <InputNumber />
                </Form.Item>

                <br/>
                <Form.Item label={null}>
                    <Button type="primary" htmlType="submit" disabled={isLoading || !!error}>
                        Save
                    </Button>
                </Form.Item>
            </Form>

        </Card>
    )
}